import React from 'react';
import Header from '../Header/Header';
import Product from './Product/Product';


export default function Home(){
    return(
        <div>
        <Header/>
        <div className="flex content-center ml-auto mr-auto max-w-screen-xl">
            <div className="w-full">
                <div className="flex z-50 mx-4 max-md:flex-col">
                    <Product
                        id="1"
                        title="Xiaomi Redmi Note 11 Graphite Gray 6GB Ram 128GB Rom"
                        price={1355.00}
                        rating={5}
                        image="https://m.media-amazon.com/images/I/51e3KdrHuCL._AC_SL1080_.jpg"
                    />
                    <Product
                        id="2"
                        title="Controle Dualshock 4 - PlayStation 4 - Preto"
                        price={11.96}
                        rating={4}
                        image="https://m.media-amazon.com/images/I/51Ieq0twp+L._AC_SL1000_.jpg"
                    />
                </div>
                <div className="flex z-50 mx-4 max-md:flex-col">
                <Product
                        id="3"
                        title="100% Pure Creatine 300MG, Integralmedica"
                        price={132.31}
                        rating={3}
                        image="https://m.media-amazon.com/images/I/61W6nFib1UL._AC_SX522_.jpg"
                    />
                <Product
                        id="4"
                        title="Kit com 10 Cuecas Boxer Part.B"
                        price={71.93}
                        rating={2}
                        image="https://m.media-amazon.com/images/I/51lSMf4YsQL._AC_SX569_.jpg"
                    />
                <Product
                        id="5"
                        title="Musashi - Box 3 volumes"
                        price={168.52}
                        rating={5}
                        image="https://m.media-amazon.com/images/I/91nQN31di-L.jpg"
                    />
                </div>
                <div className="flex z-50 mx-4 max-md:flex-col">
                <Product
                        id="6"
                        title="Echo Dot (3ª Geração): Smart Speaker com Alexa - Cor Preta"
                        price={331.55}
                        rating={5}
                        image="https://m.media-amazon.com/images/I/41GZCWFJB1L._AC_.jpg"
                    />
                
                </div>
                
            </div>
        </div>
    </div>
    )
}